import BaseSelete from './base-selete'
import ComplexSelect from './complex-select'

export default {
    install: function(Vue) {
        Vue.component('BaseSelete', BaseSelete)
        Vue.component('ComplexSelect', ComplexSelect)
    }
}